import _ from "lodash";

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// eslint-disable-next-line no-useless-escape
const pwdRegex = /^(?=\P{Ll}*\p{Ll})(?=\P{Lu}*\p{Lu})(?=\P{N}*\p{N})(?=[\p{L}\p{N}]*[^\p{L}\p{N}])[\s\S]{8,}$/u;

const validEmail = email => {
  var re = emailRegex;
  return re.test(email);
};

const validPassword = password => {
  var re = pwdRegex;
  return re.test(password);
};

const validate = (fields, form) => {
  var result = {
    valid: true,
    errors: []
  };

  _.each(fields, group => {
    _.each(group.fields, field => {
      if (field.required && field.type === "datetime") {
        if (
          field.required &&
          (_.isEmpty(form[field.name + "_date"]) ||
            _.isEmpty(form[field.name + "_time"]))
        ) {
          result.valid = false;
          result.errors.push(field);
        }
      } else if (field.required && _.isEmpty(form[field.name])) {
        result.valid = false;
        result.errors.push(field);
      }
      if (field.type === "number") {
        if (field.min && field.min > form[field.name]) {
          result.valid = false;
          result.errors.push(field);
        }
      }
    });
  });

  return result;
};

export { validEmail, validPassword, validate, emailRegex, pwdRegex };
